import { ISelectOption, ModalPopup, Select } from '@aon/aon-tws-common-ui';
import { ILibraryQuestion } from '@aon/tws-common-ui-questions/build/lib/models';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import contentConstants from '../../contentConstants';
import { IApplicationState } from '../../store';

export const TitleContainer = styled.div`
	color: #444444;
	font-family: Montserrat;
	font-size: 20px;
	font-weight: 600;
	letter-spacing: 0;
	line-height: 22px;
`;
TitleContainer.displayName = 'TitleContainer';

const InstructionsContainer = styled.div`
	padding-bottom: 22px;
	height: 104px;
`;
InstructionsContainer.displayName = 'InstructionsContainer';

const QuestionContainer = styled.div`
	text-align: left;
	color: #444444;
	font-family: Montserrat;
	font-size: 14.5px;
	font-weight: 600;
	letter-spacing: 0;
	line-height: 19px;
	padding-bottom: 10px;
`;
QuestionContainer.displayName = 'QuestionContainer';

const SelectContainer = styled.div`
	text-align: left;
	height: 31px;
`;
SelectContainer.displayName = 'SelectContainer';

const ModalContainer = styled.div`
	display: block;
`;
ModalContainer.displayName = 'ModalContainer';

const SelectScoredDimensionModalPopup = styled(ModalPopup)`
	.modal-body {
		overflow: unset;
	}
`;
SelectScoredDimensionModalPopup.displayName = 'SelectScoredDimensionModalPopup';

export interface ISelectScoredDimensionModalProps {
	isOpen: boolean;
	onClose: () => void;
	onSubmit: (question: ILibraryQuestion | undefined, selectedDimension: string) => void;
}

export const SelectScoredDimensionModal = (props: ISelectScoredDimensionModalProps) => {
	const [selectedDimension, setDimension] = useState('');
	const selectedQuestion = useSelector((state: IApplicationState) => state.commonQuestionList.selectedQuestion);

	const handleClose = () => {
		props.onClose();
		setDimension('');
	};

	const handleSubmit = () => {
		props.onSubmit(selectedQuestion, selectedDimension);
		setDimension('');
	};

	let scoredDimensions: string[] = [];
	let questionText = '';
	if (selectedQuestion && selectedQuestion !== undefined && selectedQuestion.scoredDimensionNames) {
		scoredDimensions = selectedQuestion.scoredDimensionNames;
		questionText = selectedQuestion.text;
	}

	const dropdownItems = PopulateDropdownItems(scoredDimensions);

	return (
		<SelectScoredDimensionModalPopup
			isOpen={props.isOpen}
			title={<TitleContainer>{contentConstants.SELECT_SCORED_DIMENSION_MODAL_TITLE}</TitleContainer>}
			type={'lightbox'}
			onClosed={handleClose}
			onSubmit={handleSubmit}
			primaryButtonText={contentConstants.BUTTONS_CONFIRM}
			secondaryButtonText={contentConstants.BUTTONS_CANCEL}
		>
			<ModalContainer>
				<InstructionsContainer>
					{contentConstants.SELECT_SCORED_DIMENSION_MODAL_INSTRUCTIONS_PART_ONE}
					<b>{contentConstants.SELECT_SCORED_DIMENSION_MODAL_INSTRUCTIONS_PART_TWO}</b>
					{contentConstants.SELECT_SCORED_DIMENSION_MODAL_INSTRUCTIONS_PART_THREE}
				</InstructionsContainer>

				<QuestionContainer>{questionText}</QuestionContainer>
				<SelectContainer>
					<Select
						items={dropdownItems}
						selectWidth='244px'
						displayText={contentConstants.SELECT_SCORED_DIMENSION_MODAL_DROPDOWN_TEXT}
						onApply={(value: any) => setDimension(value)}
						selectedValue={selectedDimension}
					/>
				</SelectContainer>
			</ModalContainer>
		</SelectScoredDimensionModalPopup>
	);
};

export const PopulateDropdownItems = (items: string[]) => {
	const firstItem: ISelectOption = {
		name: 'No Dimension',
		displayOrder: 0,
		displayText: 'No Dimension',
	};
	const displayItems: ISelectOption[] = items.map((item, index) => ({
		name: item,
		displayOrder: index + 1,
		displayText: item,
	}));

	const result: ISelectOption[] = [{ ...firstItem }, ...displayItems];
	return result;
};
